













































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import { documentGeneratorApi } from "@/getinfo-api";
import { fileInformation, FileType } from "@/utils/files-helper";
import {
  generateDocumentApiMethodByType,
  generateMultiplyDocumentApiMethodByType
} from "@/utils/document-generator-helper";
import { Generate as IGenerate } from "@/api-v2/document-generator/models/generate";
import { GenerateResult as IGenerateResult } from "@/api-v2/document-generator/models/generate-result";
import {
  TemplateFile as ITemplateFile,
  TemplateFileContextEnum
} from "@/api-v2/document-generator/models/template-file";
import moment from "moment";

@Component({
  components: { CustomButton }
})
export default class DocTemplateGenerateV2 extends Vue {
  @Prop() readonly fileName?: string;
  @Prop() readonly context!: TemplateFileContextEnum;
  @Prop() readonly companyId!: string;
  @Prop() readonly entityId!: string;
  @Prop() readonly entityIds!: string[];
  @Prop({ default: "" }) readonly entityTitle!: string;
  @Prop({ default: false }) readonly scopeCreate!: boolean;
  @Prop() readonly scopeData?: Array<{ id: string; number: string }>;
  @Prop({ default: false }) isMultiplyGenerate?: boolean;
  generateResults: IGenerateResult[] = [];
  generateResult!: IGenerateResult;
  templates: ITemplateFile[] = [];
  selectedTemplate!: ITemplateFile;
  isLoading: boolean = false;
  count: number = 0;

  data() {
    return {
      selectedTemplate: undefined,
      generateResult: undefined
    };
  }

  get generateParams(): IGenerate {
    return {
      inputFileId: this.selectedTemplate?.fileId ?? "",
      outputDiskId: this.$store?.getters?.selectedCompany?.diskId ?? "",
      outputPath: this.generatePath()
    };
  }

  fileInfo(file: FileType) {
    return fileInformation(file);
  }

  generatePath(_name?: string) {
    let name = this.entityTitle
      ? `${this.translateType(this.context)}-${this.entityTitle +
          "-"}${moment().format("DD.MM.YYYY-LT")}${
          this.count === 0 ? "" : " " + this.count
        }`
      : `${_name ?? this.entityTitle}${
          this.count === 0 ? "" : " " + this.count
        }`;

    if (this.fileName) name = this.fileName;
    if (_name) name = _name;

    const folder = this.selectFolderForGeneratedFiles(this.context)
      ? this.selectFolderForGeneratedFiles(this.context)
      : undefined;
    name += ".docx";

    return [folder, name]?.join("/");
  }

  async generateScope() {
    if (this.scopeData?.length) {
      this.scopeData?.forEach(el => {
        const params: IGenerate = {
          inputFileId: this.selectedTemplate?.fileId ?? "",
          outputDiskId: this.$store?.getters?.selectedCompany?.diskId ?? "",
          outputPath: this.generatePath(el.number)
        };

        this.generateTemplate(el.id, params);
      });
    }
  }

  async generateTemplate(entityId?: string, params?: IGenerate) {
    try {
      this.isLoading = true;

      if (!this.isMultiplyGenerate) {
        const { data } = await generateDocumentApiMethodByType(
          this.context,
          entityId ?? this.entityId,
          params ?? this.generateParams
        )!;
        this.generateResult = data;
        this.count++;
        this.$emit("getFileId", [data.id]);
        this.downloadFile(data.url);
        await this.$store.dispatch("successToast", {
          message: this.$tc(this.$translate.Successful)
        });
      } else {
        const { data } = await generateMultiplyDocumentApiMethodByType(
          this.context,
          this.entityIds,
          params ?? this.generateParams
        )!;
        this.generateResult = data;
        this.$emit("getFileId", [data.id]);
        this.downloadFile(data.url);
        await this.$store.dispatch("successToast", {
          message: this.$tc(this.$translate.Successful)
        });
      }
    } catch (e) {
      console.warn(e);
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async getTemplatesByContext() {
    try {
      this.isLoading = true;
      const {
        data
      } = await documentGeneratorApi.TemplateFiles.listTemplateFiles(
        this.companyId,
        this.context
      );
      this.templates = data;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  selectFolderForGeneratedFiles(item: string) {
    const folderNames: { [key: string]: string } = {
      contract: "Сформированные договоры",
      bill: "Сформированные счета",
      act: "Сформированные акты",
      ["enrollment-order"]: "Сформированные приказы о зачислении",
      ["expulsion-order"]: "Сформированные приказы об отчислении",
      ["education-protocol"]: "Сформированные протоколы обучения",
      ["final-document"]: "Сформированные итоговые документы"
    };
    return folderNames[item];
  }

  translateType(type: string) {
    const translateFields: { [key: string]: string } = {
      contract: `${this.$tc(this.$translate.Contract)}`,
      bill: `${this.$tc(this.$translate.Bill)}`,
      act: `${this.$tc(this.$translate.CertificateOfCompletedWorks)}`,
      ["enrollment-order"]: "Приказ_о_зачислении",
      ["expulsion-order"]: "Приказ_об_отчислении",
      ["education-protocol"]: "Протокол_обучения",
      ["final-document"]: "Итоговый_документ"
    };

    return translateFields[type] ?? type;
  }

  getFileNameByUrl(url: string) {
    const chunks = url?.split("/");
    return chunks[chunks?.length - 1] ?? url;
  }

  downloadFile(url: string) {
    let linkToFile = document.createElement("a");
    linkToFile.href = url;
    linkToFile.target = "_blank";
    linkToFile.download = this.getFileNameByUrl(url);
    linkToFile.click();
  }

  goToCreateTemplate() {
    let link = this.$router.resolve({
      name: "docTemplatesCreate",
      query: {
        entity: this.context
      }
    });
    window.open(link.href, "_blank");
  }

  created() {
    this.getTemplatesByContext();
  }
}
